import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles/dropdownGender.module.scss'
import BtnToggle from 'components/generic/BtnToggle'
import { GenderFilter } from 'types/global'
import Dropdown from 'components/generic/Dropdown'

interface Props {
  options: { label: string; value: GenderFilter }[]
  selectedGender: GenderFilter
  setGender: (gender: GenderFilter) => void
}

const DropdownGender: React.FC<Props> = ({ options, selectedGender, setGender }) => {
  const { t: tFilterBar } = useTranslation('strFilterBar')
  const optionPressed = (i: number) => {
    setGender(options[i].value)
  }
  const [isOpen, setIsOpen] = useState(false)
  const selectedOption = options.find(option => option.value === selectedGender)
  const dropdownLabel = selectedOption?.value ? selectedOption.label : tFilterBar('anyGender')

  return (
    <Dropdown
      contentTrigger={dropdownLabel}
      withChevron
      classNames={{ content: styles.content, trigger: { '--is-active': !!selectedGender } }}
      controls={{ isOpen, setIsOpen }}
    >
      {options.map(({ label, value }, i) => (
        <BtnToggle
          isActive={selectedGender === value}
          key={label}
          onClick={() => {
            optionPressed(i)
            setIsOpen(false)
          }}
        >
          {label}
        </BtnToggle>
      ))}
    </Dropdown>
  )
}

export default DropdownGender
